<template>
<v-chart :options="option"/>
</template>
<style>

.echarts {
  width: 100%;
  height: 100%;
}
</style>
<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import _ from 'lodash'
import numbro from 'numbro'

export default {
  name: 'nested-pie',
  components: {
    'v-chart': ECharts
  },
  data () {
    return {
      oldSeries: [],
      newSeries: [],
      legendData:[]
    } 
  },
  methods:{

    formatDataAsCurrency(value){
        return numbro(value).formatCurrency({
                  average: true,
                  mantissa: 1,
                  optionalMantissa: true
                })
    },
    formatDataAsPercentageVariation(value){
        return numbro(value).format({
                  forceSign:true,
                  mantissa: 0,
                  output: 'percent'
                })
    },
    processData(){
      // get old and new data series, as well as data legend
      var oldSeries = [];
      var newSeries = [];
      var legendData = [];
      _.forEach(this.series, function(channel){
        // var currencyData = this.formatDataAsCurrency(channel.oldValue)
        var oldValue = numbro(channel.oldValue).formatCurrency({
                  // average: true,
                  mantissa: 1,
                  optionalMantissa: true,
                  thousandSeparated: true,
                })
        
        // console.log(`old Value: ${oldValue}`)
        var oldChannelObject = {
            name : channel.name,
            value : channel.oldValue
        }
        // be aware of substraction accuracy in js .i.e. 1.2 - 1 = 0.19999999999999996
        var percentageDifference = ((channel.newValue/channel.oldValue) - 1)
        percentageDifference = _.round((percentageDifference), 2)
        // console.log(`percentage difference: ${percentageDifference}%`)
        var newChannelObject = {
            name : channel.name,
            value : channel.newValue,
            percentageDifference : percentageDifference
        }        
        oldSeries.push(oldChannelObject)  
        newSeries.push(newChannelObject)
        legendData.push(channel.name)
          
      })

      this.oldSeries = oldSeries;
      this.newSeries = newSeries;
      this.legendData = legendData;
      // console.log(this.legendData)
        
    }
  },
  mounted() {
    this.processData()
  },
  watch: {
    series: function () {
      this.processData()
    }
  },
  computed: {
    option(){
      return {
        title: {
          x: 'center',
          top: 20,
          text: this.text,
          subtext: this.subtext
        },
        tooltip: {
          show: false,
          trigger: 'item',
          // formatter: "{a} <br/>{b}: {c} ({d}%)",
          /* formatter: (params => {
            var paramsSeriesName = params['seriesName']
            var oldInvestment = this.formatDataAsCurrency(params['value'])
            var percentPie = params['percent']
            var label = [
              `${paramsSeriesName}`, 
              `${oldInvestment}`,
              `% of Investment: ${percentPie}%`,
            
            ].join('<br/>') 
            return label
          }) */
        },
        series: [
        {
          name:'Old Investment',
          type:'pie',
          selectedMode: 'single',
          radius: [0, '40%'],
          center: ['50%', '60%'],
          label: {
            normal: {
              position: 'inner',
              show: true,
              textBorderColor: '#333',
              textBorderWidth: 2,
              fontSize: 11,
              fontFamily: 'Roboto,sans-serif',
            }
          },
          labelLine: {
            normal: {
             show: false
            }
          },
          data: this.oldSeries
        },
        {
          name:'Recommendation',
          type:'pie',
          
          radius: ['50%', '60%'],
          center: ['50%', '60%'],
          label: {
            normal: {
              formatter: (params => {

                var paramName = params['name']
                var percentageDifference = this.formatDataAsPercentageVariation(params['data'].percentageDifference)
                var newInvestment = this.formatDataAsCurrency(params['value'])
                var label =  [
                  `{title| ${paramName}}{abg|}`,
                  '{hr|}',
                  `{row|}{headerLeft|Spend}{value|${newInvestment}}`,
                  `{row|}{headerLeft|Variation}{percent|${percentageDifference}}`,
                ].join('\n')

                var per = params['data'].percentageDifference < 0 ? 'per_negative' : 'per_positive'
                var lab = `{a|${paramName}}\n{hr|}\n  {b|${newInvestment}}  {${per}|${percentageDifference}} `
                return lab

              }),
              backgroundColor: '#eee',
              borderColor: '#aaa',
              borderWidth: 1,
              borderRadius: 4,
              rich: {
                a: {
                    lineHeight: 22,
                    align: 'center',
                    fontWeight: 'bold'
                },
                hr: {
                    borderColor: '#aaa',
                    width: '100%',
                    borderWidth: 0.5,
                    height: 0
                },
                b: {
                    fontSize: 16,
                    lineHeight: 33,
                    color: 'black'
                },
                per_positive: {
                    color: '#eee',
                    backgroundColor: '#334455',
                    padding: [2, 4],
                    borderRadius: 3
                },
                per_negative: {
                    color: '#eee',
                    backgroundColor: 'darkred',
                    padding: [2, 4],
                    borderRadius: 3
                }
              }
            }
          },
          data: this.newSeries
        }
        ]
      }
    }
      },      
    props: {
      source:{
      type: Array
      },
      series: {
      type: Array,
      required: true
      },
      toolbox: {
      required: false,
      default: false
      },
      text: {
      type: String,
      required: false
      },
      subtext: {
      type: String,
      required: false
      }
    }
}
</script>